import { get, del, post } from './apiUtils';

const defaultUrl = '/SubstanceProportions/';

export default {
  getSubstanceProportionList: () => get(defaultUrl),
  deleteSubstanceProportion: id => del(`${defaultUrl}${id}`),
  saveSubstanceProportion: data => post(defaultUrl, data),
};
